export class PhoneCodeToggler {
  constructor({ countryInput, countryCodeLabel, phoneCodes }) {

    this.countryInputSelector = countryInput;
    this.countryCodeLabelSelector = countryCodeLabel;
    this.countryPhoneCodes = phoneCodes;
  }

  handler() {

    const { countryInputSelector, countryCodeLabelSelector, countryPhoneCodes } = this;

    if (countryInputSelector) {

      $(countryInputSelector).on('change', (e) => {
        const selectedCountry = $(e.target).val();

        if (selectedCountry.length) {
          const phoneCode = countryPhoneCodes.find((obj) => obj.code === selectedCountry).dial_code;

          $(countryCodeLabelSelector).html(phoneCode);
        } else {
          $(countryCodeLabelSelector).html('+1');
        }
      });

    }
  }

  init() {
    this.handler();
  }
}
